/**
 * WorkflowShell — domain frame for signing / pipeline / task workflow config.
 *
 * New module landed 2026-06-16 (BACKLOG-0579/0101) as the migrate target for
 * the ROP-teams Admin workflow editors. Signing Engine Routing is first — it
 * was the prior Slot-C violation (admin config wrongly registered in the
 * operational ROP-teams app). Signature Auth Rules, Wet-Sign Attestation,
 * Task Templates, and Weekly Task Criteria slot in as siblings.
 *
 * Mirrors ComplianceShell / DocumentsShell — a DomainShell with a role-gated
 * sub-nav.
 */

import { useAuth } from '@/contexts/AuthContext';
import { DomainShell } from '@/components/DomainShell';

const REQ = ['SuperAdmin', 'Admin'] as const;

const SUBNAV = [
  { slug: 'signing-engine-routing', label: 'Signing Engine Routing', requiredRoles: REQ },
  { slug: 'signature-auth-rules', label: 'Signature Auth Rules', requiredRoles: REQ },
  { slug: 'wet-sign-attestation-box', label: 'Wet-Sign Attestation', requiredRoles: REQ },
  { slug: 'task-templates', label: 'Task Templates', requiredRoles: REQ },
  { slug: 'weekly-task-criteria', label: 'Weekly Task Criteria', requiredRoles: REQ },
];

export function WorkflowShell(): JSX.Element {
  const { user } = useAuth();
  return (
    <DomainShell
      title="Workflow"
      description="The signing, pipeline, and task workflow config. Signing Engine Routing is the Q3 kill-switch — which signing engine (Internal / SignNow / Wet-attested) handles each document, for each customer type, on each surface. The orchestrator reads it at signing time, so a one-row flip reroutes a cohort in seconds with no deploy. Signature auth rules, wet-sign attestation boxes, task templates, and weekly task criteria join as their editors land. Risk Mgmt sign-off is required before changing any Phase-1 routing row in production."
      basePath="/retail/workflow"
      items={SUBNAV.map((s) => ({
        slug: s.slug,
        label: s.label,
        requiredRoles: s.requiredRoles,
      }))}
      userRoles={user?.roles ?? []}
    />
  );
}
